import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth/auth.module';
import teacher from './modules/teacher/teacher.module';
import courses from './modules/courses/courses.module';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  // strict: true,
  modules: {
    auth,
    teacher,
    courses,
  },
  plugins: [
    createPersistedState({
      paths: ["auth", "teacher"]
    })
  ]
});
